import { useEffect, useState } from 'react';
import { useCurrentAccountId } from '@adsk/alloy-provider';
import { useDataApi } from '@adsk/alloy-helpers';
import { buildGetAccountUsersRequest } from './utils';

const useGetAccountUsers = ({ includeAllMembers }) => {
  const accountId = useCurrentAccountId();
  const [debouncedEmailInput, setDebouncedEmailInput] = useState('');
  const { data: accountUsersData, doFetch: doGetAccountUsers } = useDataApi();

  const handleEmailInputChange = (emailInput) => {
    setDebouncedEmailInput(emailInput);
  };

  useEffect(() => {
    if (!accountId) return;

    doGetAccountUsers(
      buildGetAccountUsersRequest({
        accountId,
        search: debouncedEmailInput,
        includeAllMembers,
      })
    );
  }, [debouncedEmailInput, accountId, doGetAccountUsers, includeAllMembers]);

  return {
    handleEmailInputChange,
    accountUsersData,
  };
};

export default useGetAccountUsers;
